import styled from "styled-components";
import { Link, Grid } from "@material-ui/core";

export const STItemGrid = styled(Grid)`
  && {
    display: flex;
    align-items: center;
  }
`;
export const STGrid = styled(Grid)`
  && {
    height: 100%;
    padding-bottom: 16px;
  }
`;
